__turbopack_export_value__({
  "body-logo-18": "topMenu-module-scss-module__IT1j8G__body-logo-18",
  "body-text-12": "topMenu-module-scss-module__IT1j8G__body-text-12",
  "body-text-14": "topMenu-module-scss-module__IT1j8G__body-text-14",
  "body-text-16": "topMenu-module-scss-module__IT1j8G__body-text-16",
  "body-text-18": "topMenu-module-scss-module__IT1j8G__body-text-18",
  "body-text-20": "topMenu-module-scss-module__IT1j8G__body-text-20",
  "body-text-24": "topMenu-module-scss-module__IT1j8G__body-text-24",
  "body-text-24-2": "topMenu-module-scss-module__IT1j8G__body-text-24-2",
  "body-text-heading-2": "topMenu-module-scss-module__IT1j8G__body-text-heading-2",
  "body-text-heading-3": "topMenu-module-scss-module__IT1j8G__body-text-heading-3",
  "body-text-medium-14": "topMenu-module-scss-module__IT1j8G__body-text-medium-14",
  "body-text-medium-16": "topMenu-module-scss-module__IT1j8G__body-text-medium-16",
  "body-text-medium-18": "topMenu-module-scss-module__IT1j8G__body-text-medium-18",
  "body-text-medium2-18": "topMenu-module-scss-module__IT1j8G__body-text-medium2-18",
  "body-text2-14": "topMenu-module-scss-module__IT1j8G__body-text2-14",
  "body-text2-16": "topMenu-module-scss-module__IT1j8G__body-text2-16",
  "button-primary-text": "topMenu-module-scss-module__IT1j8G__button-primary-text",
  "button-text": "topMenu-module-scss-module__IT1j8G__button-text",
  "button2-text": "topMenu-module-scss-module__IT1j8G__button2-text",
  "card-shadow": "topMenu-module-scss-module__IT1j8G__card-shadow",
  "effect-menu": "topMenu-module-scss-module__IT1j8G__effect-menu",
  "header-1": "topMenu-module-scss-module__IT1j8G__header-1",
  "main-container": "topMenu-module-scss-module__IT1j8G__main-container",
  "main-footer-container": "topMenu-module-scss-module__IT1j8G__main-footer-container",
  "main-header-container": "topMenu-module-scss-module__IT1j8G__main-header-container",
  "notice": "topMenu-module-scss-module__IT1j8G__notice",
  "notice__phone": "topMenu-module-scss-module__IT1j8G__notice__phone",
  "phone": "topMenu-module-scss-module__IT1j8G__phone",
  "shedule": "topMenu-module-scss-module__IT1j8G__shedule",
  "topMenu": "topMenu-module-scss-module__IT1j8G__topMenu",
  "topMenu__button": "topMenu-module-scss-module__IT1j8G__topMenu__button",
  "topMenu__buttonWrapper": "topMenu-module-scss-module__IT1j8G__topMenu__buttonWrapper",
  "topMenu__contactsWrapper": "topMenu-module-scss-module__IT1j8G__topMenu__contactsWrapper",
  "topMenu__container": "topMenu-module-scss-module__IT1j8G__topMenu__container",
  "topMenu__phoneWrapper": "topMenu-module-scss-module__IT1j8G__topMenu__phoneWrapper",
  "topMenu__status": "topMenu-module-scss-module__IT1j8G__topMenu__status",
  "topMenu_burger": "topMenu-module-scss-module__IT1j8G__topMenu_burger",
  "txt-12-bold": "topMenu-module-scss-module__IT1j8G__txt-12-bold",
  "txt-14-bold": "topMenu-module-scss-module__IT1j8G__txt-14-bold",
  "txt-14-bold-caps": "topMenu-module-scss-module__IT1j8G__txt-14-bold-caps",
  "txt-14-med": "topMenu-module-scss-module__IT1j8G__txt-14-med",
  "txt-16-bold": "topMenu-module-scss-module__IT1j8G__txt-16-bold",
  "txt-16-med": "topMenu-module-scss-module__IT1j8G__txt-16-med",
  "txt-18-bold": "topMenu-module-scss-module__IT1j8G__txt-18-bold",
  "txt-18-medium": "topMenu-module-scss-module__IT1j8G__txt-18-medium",
  "txt-18-medium-24": "topMenu-module-scss-module__IT1j8G__txt-18-medium-24",
  "txt-24-semi": "topMenu-module-scss-module__IT1j8G__txt-24-semi",
});
